import { memo, useCallback } from 'react'
import { ShoppingCart } from 'lucide-react'
import { Badge } from '@/components/ui/badge'
import { useCart } from '@/stores/useCart'

export const CartIcon = memo(() => {
  const { totalItems, toggleCart } = useCart()

  const handleClick = useCallback(() => {
    toggleCart()
  }, [toggleCart])

  return (
    <div>
      <button
        onClick={handleClick}
        className="relative h-9 w-9 p-0 rounded-lg bg-gradient-to-r from-brand-purple/8 via-brand-pink/8 to-brand-blue/8 backdrop-blur-sm border border-brand-purple/20 shadow-sm hover:shadow-md transition-all duration-300 group"
        aria-label="Warenkorb"
        style={{
          WebkitTapHighlightColor: 'transparent',
          WebkitTouchCallout: 'none',
          WebkitUserSelect: 'none',
          userSelect: 'none',
        }}
      >
        {/* Morphing Hover Effect */}
        <div className="absolute inset-0 rounded-lg bg-gradient-to-r from-brand-purple/10 via-brand-pink/10 to-brand-blue/10 backdrop-blur-sm opacity-0 group-hover:opacity-100 transition-all duration-300 ease-out"></div>

        {/* Icon */}
        <div className="relative z-10 flex items-center justify-center">
          <ShoppingCart className="h-5 w-5 text-muted-foreground/80 group-hover:text-brand-purple transition-colors duration-200" />
        </div>

        {/* Badge */}
        {totalItems > 0 && (
          <Badge
            variant="destructive"
            className="absolute -top-1 -right-1 h-5 w-5 rounded-full p-0 flex items-center justify-center text-xs bg-brand-pink text-white border-2 border-background shadow-sm"
          >
            {totalItems > 99 ? '99+' : totalItems}
          </Badge>
        )}
      </button>
    </div>
  )
})

CartIcon.displayName = 'CartIcon'
